import React, { Component } from 'react';
import _ from 'underscore';
import { Row, Col, Table, Button, Popconfirm, Pagination, Checkbox, Input } from 'antd';
import FormModal from '../../components/FormModal2';
import { app } from "../../app";
import api from "../../api";
import utils from "../../utils";

class TETeamDynamic extends Component {
    constructor (props) {
        super(props);
        this.state = {
            selectedRowKeys: [],
            dataList: [],
            recordList: [],
            operation: 0,
            rtotal: 0,
            rpage: 1,
            total: 0,
            page: 1,
            edit_item: {},
            show_record: false,
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    async componentWillReceiveProps (props) {
        let { team } = this.props;
        if (team.teamno !== props.team.teamno) {
            let { show_record } = this.state;
            let state = {
                dataList: [],
                recordList: [],
                operation: 0,
                rtotal: 0,
                rpage: 1,
                total: 0,
                edit_item: {},
            };
            if (show_record) {
                state.show_record = false;
            }
            await this.setData(state);
            await this.handleData();
        }
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true });
        let { team } = this.props,
            params = {
                page,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamDynamicsList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (page === this.state.page) {
            let operation = 0;
            for (let i = 0; i < data.length; i++) {
                if (data[i].is_operate === 1) operation++;
            }
            this.setData({
                operation,
                selectedRowKeys: [],
                data_loading: false,
                dataList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            });
        }
    };

    /**
     * 操作记录数据处理
     * @param rpage
     * @returns {Promise<void>}
     */
    handleRecordData = async (rpage = 1) => {
        await this.setData({ rpage, record_loading: true });
        let { team } = this.props,
            params = {
                page: rpage,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamDynamicsOperateList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (rpage === this.state.rpage) {
            this.setData({
                record_loading: false,
                recordList: utils.addArrayKey(data),
                rtotal: parseInt(total || 0),
            });
        }
    };

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = (e) => {
        let checked = e.target.checked;
        let selectedRowKeys = [];
        if (checked) {
            selectedRowKeys = _.range(1, this.state.dataList.length + 1);
        }
        this.setData({ selectedRowKeys });
    };

    /**
     * 关闭编辑框
     * @param e
     */
    handleCloseEditModal = () => {
        this.setData({ edit_visible: false });
    }

    /**
     * 打开编辑框
     * @param e
     */
    handleOpenEditModal = (edit_item = {}) => {
        this.setData({ edit_visible: true, edit_item });
    }

    /**
     * 编辑
     * @param values
     */
    handleEdit = async ({ content }) => {
        if (this.state.edit_loading) return;
        await this.setData({ edit_loading: true });
        let { team } = this.props, { edit_item, page } = this.state, params = {
            content,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let state = { edit_loading: false };
        if (edit_item.id) {
            params.id = edit_item.id;
            let { flag, msg } = await app.post(api.TeamDynamicsSave, params);
            await this.setData(state);
            if (flag === 1) {
                app.alert("编辑成功", "success");
                this.handleCloseEditModal();
                await this.handleData(page);
            } else {
                app.alert(msg, "error");
            }
        } else {
            params.teamno = team.teamno;
            let { flag, msg } = await app.post(api.TeamDynamicsAdd, params);
            await this.setData(state);
            if (flag === 1) {
                app.alert("发布成功", "success");
                this.handleCloseEditModal();
                await this.handleData(page);
            } else {
                app.alert(msg, "error");
            }
        }
    }

    /**
     * 删除
     * @param indexs
     * @returns {Promise<void>}
     */
    handleDelete = async (indexs) => {
        let { page, total, dataList } = this.state;
        let ids = [];
        for (let i = 0; i < dataList.length; i++) {
            if (indexs.indexOf(i + 1) > -1) {
                ids.push(dataList[i].id);
            }
        }
        let count = total - ids.length,
            lp = count % 20 === 0 ? parseInt(count / 20) : parseInt(count / 20) + 1;
        if (page > lp) page = lp;
        let id = ids.join(","), params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, msg } = await app.post(api.TeamDynamicsDel, params);
        if (flag === 1) {
            app.alert("删除成功", "success");
            await this.handleData(page);
        } else {
            app.alert(msg, "error");
        }
    }

    render () {
        let { data_loading, record_loading, recordList, dataList, selectedRowKeys, total, page, rtotal, rpage, edit_visible, edit_item, edit_loading, show_record, operation } = this.state,
            rowSelection = {
                selectedRowKeys,
                getCheckboxProps: (record) => {
                    let props = {};
                    if (record.is_operate !== 1) {
                        props.disabled = true;
                    }
                    return props;
                },
                onChange: (keys) => {
                    this.setData({ selectedRowKeys: keys });
                }
            },
            columns = [
                {
                    title: '队伍更新时间',
                    dataIndex: 'submit_time',
                    key: 'submit_time',
                    width: '20%'
                },
                {
                    title: '内容',
                    dataIndex: 'dynamics_content',
                    key: 'dynamics_content',
                    width: '40%'
                },
                {
                    title: '发布人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '20%'
                },
                {
                    title: '操作',
                    dataIndex: 'is_operate',
                    key: 'is_operate',
                    width: '20%',
                    render: (is_operate, item, index) => {
                        if (is_operate === 1) {
                            let disabled = selectedRowKeys.length > 1;
                            return (
                                <span>
                            <Popconfirm placement="bottom"
                                        title="确定删除？"
                                        cancelText="取消"
                                        okText="确定"
                                        onConfirm={() => this.handleDelete([index + 1])}
                            >
                                <Button size="small" type="danger" style={{ marginRight: 20 }} disabled={disabled}
                                        ghost>删除</Button>
                            </Popconfirm>
                            <Button size="small" type="primary"
                                    onClick={() => this.handleOpenEditModal(item)} disabled={disabled}>编辑</Button>
                        </span>
                            )
                        } else {
                            return <span style={{ color: "#999" }}>无权操作</span>;
                        }
                    }
                },
            ],
            columns2 = [
                {
                    title: '操作时间',
                    dataIndex: 'work_time',
                    key: 'work_time',
                    width: '20%'
                },
                {
                    title: '操作前',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '20%'
                },
                {
                    title: '操作后',
                    dataIndex: 'work_after',
                    key: 'work_after',
                    width: '20%'
                },
                {
                    title: '操作记录',
                    dataIndex: 'work_status',
                    key: 'work_status',
                    width: '20%',
                    render (status, { update_type }) {
                        let text = '';
                        switch (status) {
                            case '1':
                                text = '添加';
                                break;
                            case '2':
                                text = '编辑';
                                break;
                            case '3':
                                text = '删除';
                                break;
                            default:
                                text = '';
                                break;
                        }
                        return text + update_type;
                    }
                },
                {
                    title: '操作人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '20%'
                },
            ];
        return (
            <div className="team-dynamic">
                <Row className="head" type="flex" justify="space-between">
                    <Button onClick={async () => {
                        this.setData({ show_record: !show_record })
                        await this.handleRecordData();
                    }}>{show_record ? '返回' : '操作记录'}</Button>
                    <h2 className="title">队伍动态</h2>
                    <div style={{ minWidth: 100 }}>
                        <Button onClick={() => this.handleOpenEditModal()} hidden={show_record}>发布动态</Button>
                    </div>
                </Row>
                <div style={{ height: 'calc(100% - 41.5px)' }} hidden={!show_record}>
                    <Table columns={columns2}
                           locale={app.tbLocale(record_loading)}
                           dataSource={recordList}
                           loading={record_loading}
                           scroll={{ y: 'calc(100% - 103px)' }}
                           style={{ height: '100%', margin: 0 }}
                           className="ranks_table"
                           pagination={false}
                           size="small"
                           footer={recordList.length === 0 ? null : () => {
                               return (
                                   <div style={{ textAlign: 'right' }}>
                                       <Pagination total={rtotal} size="small" pageSize={20} current={rpage}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handleRecordData}/>
                                   </div>
                               );
                           }}
                    />
                </div>
                <div style={{ height: 'calc(100% - 41.5px)', margin: 0 }} hidden={show_record}>
                    <Table columns={columns}
                           locale={app.tbLocale(data_loading)}
                           dataSource={dataList}
                           loading={data_loading}
                           scroll={{ y: 'calc(100% - 103px)' }}
                           style={{ height: '100%', margin: 0 }}
                           className="ranks_table"
                           rowSelection={rowSelection}
                           pagination={false}
                           size="small"
                           footer={dataList.length === 0 ? null : () => {
                               return (
                                   <Row>
                                       <Col span={10}>
                                           <div>
                                               <Checkbox
                                                   checked={operation !== 0 && operation === selectedRowKeys.length}
                                                   onChange={this.handleAllSel} disabled={operation === 0}>全选</Checkbox>
                                               <Popconfirm title="确定删除？"
                                                           cancelText="取消"
                                                           okText="确定"
                                                           onConfirm={() => this.handleDelete(selectedRowKeys)}
                                               >
                                                   <Button style={{ margin: '0 20px' }}
                                                           disabled={selectedRowKeys.length === 0}
                                                           type="danger">删除</Button>
                                               </Popconfirm>
                                           </div>
                                       </Col>
                                       <Col span={14} style={{ textAlign: 'right' }}>
                                           <Pagination total={total} size="small" pageSize={20}
                                                       current={page}
                                                       showTotal={(total) => `总数量：${total}`}
                                                       onChange={this.handleData}/>
                                       </Col>
                                   </Row>
                               );
                           }}
                    />
                </div>
                <FormModal
                    modal={{
                        visible: edit_visible,
                        title: edit_item.id ? "编辑动态" : "发布最新动态",
                        onCancel: this.handleCloseEditModal,
                        okText: "确认",
                        cancelText: "取消",
                        confirmLoading: edit_loading,
                        maskClosable: false,
                        destroyOnClose: true,
                    }}
                    onSubmit={this.handleEdit}
                >
                    {
                        [
                            {
                                formItemLayout: {
                                    labelCol: { span: 6 },
                                    wrapperCol: { span: 16, offset: 1 },
                                },
                                label: "动态内容",
                                name: "content",
                                options: {
                                    rules: [
                                        { required: true, message: '请输入内容' },
                                    ],
                                    initialValue: edit_item.dynamics_content
                                },
                                component: (
                                    <Input.TextArea placeholder="填写内容" autosize={{ minRows: 4, maxRows: 10 }}/>
                                )
                            }
                        ]
                    }
                </FormModal>
            </div>
        );
    }
}

export default TETeamDynamic;



// WEBPACK FOOTER //
// ./src/routes/ranks/TETeamDynamic.jsx